<!--
* @Description:试卷管理 详情
* @Author: ZSC
* @Date: 2023-03-08 14:26:07.84
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-09-27 14:01:03
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false"
      destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">试卷管理详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="试卷名称" label-align="right" align="left" width="120px" span="4">{{ ruleForm.sjmc }}</el-descriptions-item>
        <el-descriptions-item label="满分分数" label-align="right" align="left" width="120px" span="2">{{ ruleForm.mffs }}</el-descriptions-item>
        <el-descriptions-item label="及格分数 " label-align="right" align="left" width="120px" span="2">{{ ruleForm.jgfs }}</el-descriptions-item>
          <el-descriptions-item label="建议考试时长" label-align="right" align="left" width="120px" span="2">{{ ruleForm.jykssc }}</el-descriptions-item>
        <el-descriptions-item label="互斥试卷" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in ruleForm.listHcsj" :key="index">
            <span v-if="index > 0">、</span>
            <span>{{ item.hcsjmc }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="试卷库" label-align="right" align="left" width="120px" span="2">
          {{ sjk.sjkmc }}
        </el-descriptions-item>
        <el-descriptions-item label="审核时间" label-align="right" align="left" width="120px" span="2">
          {{ sjk.shsj }}
        </el-descriptions-item>
        {{ sjk.shyj }}
        <el-descriptions-item label="审核状态" label-align="right" align="left" width="120px" span="2">
          {{ shzt.name }}
        </el-descriptions-item>
        <el-descriptions-item label="组卷方式" label-align="right" align="left" width="120px" span="2">
          {{ zjfs.name }}
        </el-descriptions-item>
      </el-descriptions>
      <el-table :data="ruleForm.listKc" border stripe>
        <!-- 冻结列-Left BEGIN -->
        <el-table-column label="序号" type="index" width="80" fixed align="center" />
        <!-- 冻结列-Left END -->
        <el-table-column label="课程" prop="kcmc" align="center" show-overflow-tooltip />
        <el-table-column label="教学单元" prop="qsjxdybt" align="left" show-overflow-tooltip>
          <template #default="scope">
            <p v-for="(item, index) in scope.row.listJxdy" :key="index">{{ item.jxdybt }}</p>
          </template>
        </el-table-column>
        <!-- 冻结列-Right END -->
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const zjfs = ref({})
const sjk = ref({})
const shzt = ref({})

const emits = defineEmits(['update:openDetail'])

// 组卷方式
const zjfsData = ref({ list: [] })
loadSelect({ url: '/api/v2/ziyuanku/shijuan/zujuanfangshi', data: zjfsData })

// 试卷审核状态
const shztData = ref({ list: [] })
loadSelect({ url: '/api/v2/ziyuanku/shijuan/shijuanshenhezhuangtai', data: shztData })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/ziyuanku/shijuan/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          zjfs.value = res.data.zjfs
          sjk.value = res.data.sjk
          shzt.value = res.data.sjk.shzt
          ruleForm.value.listHcsj = res.data.listHcsj
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
